import { createSelector } from 'reselect'

import { NAME } from './reducer'

const byId = state => state[NAME].byId
const allKeys = state => state[NAME].allKeys
export const getSelected = state => state[NAME].selected
export const getVisible = state => state[NAME].visible

export const getAIIdFromAttributes = (layerId, { ObjectID, OBJECTID, id }) =>
  layerId + '|' + (ObjectID || OBJECTID || id)

export const getIdsByLayerId = createSelector([allKeys], allKeys => layerId =>
  allKeys[layerId] || []
)

const getAIsByLayerId = createSelector([byId], byId => layerId =>
  byId[layerId] || {}
)

export const getAI = createSelector([getAIsByLayerId], byId => (layerId, id) =>
  byId(layerId)[id] || null
)

export const getAllAI = createSelector([byId, allKeys], (byId, allKeys) => {
  const all = []
  for (let layerId in byId) {
    const ai = allKeys[layerId] && allKeys[layerId].map(id => byId[layerId][id])
    if (ai && ai.length) {
      all.push(...ai)
    }
  }
  return all
})
